"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//tslint:disable
var anime = require("animejs");
var anime_props_adapter_1 = require("../adapters/anime-props-adapter");
var AnimeService = /** @class */ (function () {
    function AnimeService(injectables) {
        this.anime = anime; // animejs or mock instance
        this.animationIsPlaying = false; // has the animation started playing
        this.animations = []; // array holding all registered animations
        this.animConfig = { loop: false }; // sets configuration properties for the animation
        this.anime = (injectables && injectables.anime) ? injectables.anime : this.anime;
        this.initialAnimeTimeline = this.anime.timeline();
    }
    AnimeService.prototype.addAnim = function (animationProps) {
        var convertedData = anime_props_adapter_1.default.convertAnimeAnimation(animationProps);
        this.registerAnimation(convertedData);
    };
    // only create one timeline for registered animation sequences
    AnimeService.prototype.createAnimeTimeline = function () {
        var _this = this;
        if (!this.timeline) {
            this.timeline = this.anime.timeline({
                complete: function () {
                    _this.animationIsPlaying = false;
                },
                loop: false,
            });
        }
    };
    // add animation to the timeline and pause
    AnimeService.prototype.registerAnimation = function (animData) {
        this.createAnimeTimeline();
        this.pause();
        this.animations.push(animData);
    };
    // set the initial state of the animated item
    AnimeService.prototype.setInitialState = function (initStates) {
        var _this = this;
        if (Array.isArray(initStates)) {
            initStates.forEach(function (initState) {
                var cssProps = initState.state;
                var timelineProps = {
                    duration: 0,
                    targets: initState.animationOnElem,
                };
                var combinedProps = Object.assign({}, cssProps, timelineProps);
                _this.initialAnimeTimeline.add(combinedProps);
            });
        }
        else {
            var cssProps = initStates.state;
            var timelineProps = {
                duration: 0,
                targets: initStates.animationOnElem,
            };
            var combinedProps = Object.assign({}, cssProps, timelineProps);
            this.initialAnimeTimeline.add(combinedProps);
        }
        return this.initialAnimeTimeline
            .play();
    };
    // play the animation
    AnimeService.prototype.play = function () {
        var _this = this;
        if (this.animations.length >= 1) {
            this.animations.forEach(function (animData) {
                _this.timeline.add(animData);
            });
            this.animations = [];
        }
        // prevents same animation from being fired again while current animation is playing
        if (!this.animationIsPlaying) {
            this.restart();
            this.animationIsPlaying = true;
        }
        return this.timeline.finished;
    };
    // pause the animation
    AnimeService.prototype.pause = function () {
        if (this.timeline) {
            this.timeline.pause();
        }
        else {
            throw new Error('Anime timeline is not defined!');
        }
    };
    // restart the animation
    AnimeService.prototype.restart = function () {
        if (this.timeline) {
            this.timeline.restart();
        }
        else {
            throw new Error('Anime timeline is not defined!');
        }
    };
    return AnimeService;
}());
exports.default = AnimeService;
//# sourceMappingURL=anime-service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/services/animejs/anime-service.js
// module id = 1099
// module chunks = 8